import React from "react";
import { Card, Heading, Box, Flex, Button } from "theme-ui";
import { LiquityStoreState } from "@liquity/lib-base";
import { useLiquitySelector } from "@liquity/lib-react";
import { InfoMessage } from "../../../InfoMessage";
import { UnstakeAndClaim } from "../UnstakeAndClaim";
import { RemainingLQTY } from "../RemainingLQTY";
import { StaticRow } from "../../../Trove/Editor";
import { GT, LP } from "../../../../strings";
import { ClaimReward } from "../Active/ClaimReward";
import { Icon } from "../../../Icon";

const selector = ({ liquidityMiningStake3, liquidityMiningLQTYReward3 }: LiquityStoreState) => ({
  liquidityMiningStake3,
  liquidityMiningLQTYReward3
});

export const Disabled: React.FC = () => {
  const { liquidityMiningStake3, liquidityMiningLQTYReward3 } = useLiquitySelector(selector);
  const hasStake = !liquidityMiningStake3.isZero || !liquidityMiningLQTYReward3.isZero;

  return (
    <Card>
      <Heading>
        PLSX-EARN LP Staking
        <Flex sx={{ justifyContent: "flex-end" }}>
          <RemainingLQTY />
        </Flex>
      </Heading>
      <Box sx={{ p: [2, 3] }}>
        <InfoMessage title="PLSX-EARN LP Staking period has finished">
          <Flex>There are no more FLEX rewards left to farm</Flex>
        </InfoMessage>
        {hasStake && (
          <Box>
            <Box sx={{ border: 1, pt: 3, borderRadius: 3 }}>
              <StaticRow
                label="Stake LP"
                inputId="farm-deposit"
                amount={liquidityMiningStake3.div(1e10).prettify(4)}
                unit={LP}
              />
              <StaticRow
                label="Reward"
                inputId="farm-reward"
                amount={liquidityMiningLQTYReward3.prettify(4)}
                color={liquidityMiningLQTYReward3.nonZero && "success"}
                unit={GT}
              />
            </Box>
            <Flex variant="layout.actions">
              <Button
                variant={!liquidityMiningLQTYReward3.isZero ? "outline" : "primary"}
                disabled
              >
                <Icon name="pen" size="sm" />
                &nbsp;Adjust
              </Button>
              {!liquidityMiningLQTYReward3.isZero && <ClaimReward />}
            </Flex>
            
            <UnstakeAndClaim />
          </Box>
        )}
      </Box>
    </Card>
  );
};